import OneSignal from 'react-onesignal'

// Ask user for push permission (call this after login)
export async function requestNotificationPermission() {
  try {
    await OneSignal.Slidedown.promptPush()
  } catch(e) {
    console.log('Notification prompt skipped:', e.message)
  }
}

// Tag user with their wedding ID so we can target notifications
export async function tagUser(userId, weddingId, weddingDate) {
  try {
    await OneSignal.login(userId)
    await OneSignal.User.addTags({
      wedding_id: weddingId || '',
      wedding_date: weddingDate || '',
      plan: 'free'
    })
  } catch(e) {
    console.log('OneSignal tag failed:', e.message)
  }
}

// Update plan tag when user upgrades
export async function tagPremium() {
  try {
    await OneSignal.User.addTag('plan', 'premium')
  } catch(e) {}
}

/**
 * Fire a push notification to the couple via the notify-couple edge function.
 * Silently respects the couple's notification_prefs — no-op if they turned it off.
 *
 * @param {string} weddingId
 * @param {string} title
 * @param {string} message
 * @param {'rsvp'|'checkin'|'asoebi'|'registry'} eventType
 */
export async function notifyCouple(weddingId, title, message, eventType, targetUserId) {
  try {
    await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/notify-couple`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
        'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
      },
      // targetUserId (optional) sends to just one partner; otherwise both.
      body: JSON.stringify({ wedding_id: weddingId, title, message, event_type: eventType, to_user_id: targetUserId }),
    })
  } catch (_) {}
}
